import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import LegacyEsServicesRedirect from "@/components/LegacyEsServicesRedirect";

export const Route = createFileRoute("/es/services/$")({
  head: () => buildRouteHead("/es/services/$", { noIndex: true }),
  component: LegacyEsServicesRedirect,
});
